import React from "react";
import GridImg from "components/comp/GridImg";
import Ped3 from "assets/images/sMiMs_스마트폰3.png"

const SpdstPrprtiesMain = () => {
  return (
    <div className="intro">
        <div className="Product intro">
          <div className="Product-content">
            <h3>에스페데스탈의 특징</h3>
            <div className="paragraph">
              <ul>
                <li>제조사와 무관한 Pedestal 원격 제어시스템 및 마리나 관리시스템</li>
                <li>다양한 마리나 운영 데이터의 추출(Customizing)</li>
                <li>완벽한 한글 지원(SMS), Manual, 화면 구성</li>
                <li>조명, 출입문 제어 등 필수 기능 추가</li>
                <li>별도의 RFID 카드가 필요 없어도 Mobile 장치를 통한 Pedestal 제어</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="introSub">
          <GridImg img={Ped3} width="92%" height="auto"/>
        </div>
    </div>
  );
};

export default SpdstPrprtiesMain;
